var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnDeleteAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 38,
    viewBox: "0 0 45 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1667 36.4997V32.6108C30.1667 30.548 29.3472 28.5697 27.8886 27.1111C26.43 25.6525 24.4517 24.833 22.3889 24.833H8.77778C6.71498 24.833 4.73667 25.6525 3.27806 27.1111C1.81944 28.5697 1 30.548 1 32.6108V36.4997",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5834 17.0556C19.879 17.0556 23.3612 13.5733 23.3612 9.27778C23.3612 4.98223 19.879 1.5 15.5834 1.5C11.2879 1.5 7.80566 4.98223 7.80566 9.27778C7.80566 13.5733 11.2879 17.0556 15.5834 17.0556Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7778 17.0557H32.1111",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDeleteAccount);
export default __webpack_public_path__ + "static/media/icn-delete-account.85f8e5d4a46c580cfa9539d821744af5.svg";
export { ForwardRef as ReactComponent };